export default "__VITE_ASSET__CBSG4Op$__"